module.exports = __webpack_public_path__ + "img/scene_serial.2c42c817.webp";